
import axios from "axios";
import { api } from "../config";
import * as url from "./url_helper";

axios.defaults.baseURL = api.API_URL;
axios.defaults.headers.post["Content-Type"] = "application/json";

axios.interceptors.request.use(
  (config) => {
    const authUser = JSON.parse(sessionStorage.getItem("authUser") || "{}");
    const token = authUser.token;
    
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// -------------------------------------

// Helper para quem usa headers manuais (mantido para compatibilidade)
const getDefaultHeaders = () => {
  const authUser = JSON.parse(sessionStorage.getItem('authUser')) || {};
  const token = authUser.token || '';
  
  return {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Authorization': `Bearer ${token}`
  };
};

export const setToken = (newToken) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + newToken;
};

// Alias para retrocompatibilidade
export const setAuthorization = setToken;

// Interceptor de RESPOSTA (Tratamento de erros)
axios.interceptors.response.use(
  response => response.data ? response.data : response,
  error => {
    let message;
    switch (error?.response?.status) {
      case 500: message = "Erro interno no servidor"; break;
      case 401: 
        // Opcional: Se der 401, você pode forçar o logout aqui
        // sessionStorage.removeItem("authUser");
        // window.location.href = "/login";
        message = "Credenciais inválidas ou sessão expirada"; 
        break;
      case 404: message = "Não encontrado"; break;
      default: message = error.message || error;
    }
    return Promise.reject(message);
  }
);

// Função genérica para operações CRUD
export const crudApi = (urlBase) => ({
  get: () => {
    return axios.get(urlBase, { headers: getDefaultHeaders() });
  },
  add: (data) => axios.post(urlBase, data, { headers: getDefaultHeaders() }),
  update: (data) => axios.put(urlBase, data, { headers: getDefaultHeaders() }),
  delete: (id) => axios.delete(`${urlBase}/${id}`, { headers: getDefaultHeaders() })
});

class APIClient {
  get = (url, params) => {
    let response;
    let paramKeys = [];

    if (params) {
      Object.keys(params).map(key => {
        paramKeys.push(key + '=' + params[key]);
        return paramKeys;
      });

      const queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }

    return response;
  };

  create = (url, data) => axios.post(url, data);
  update = (url, data) => axios.patch(url, data);
  put = (url, data) => axios.put(url, data);
  delete = (url, config) => axios.delete(url, { ...config });
}

export const getLoggedinUser = () => {
  const user = sessionStorage.getItem("authUser");
  return user ? JSON.parse(user)?.user : null;
};

export const login = data => axios.post(url.LOGIN, data);

export const getFeira = (chave, feiraId) => {
  const authUser = JSON.parse(sessionStorage.getItem('authUser')) || {};
  const currentToken = authUser.token || '';

  return axios.get(`${url.FEIRA_COMERCIAL_RESERVAS}/${feiraId}`, {
    headers: {
      Authorization: `Bearer ${currentToken}`,
      chave
    }
  });
}

export { APIClient };